import ApiService from "../core/services/api.service";

export default {

  getPharmacy(guid) {
    return ApiService.get(`pharmacies/${guid}`)
  },
  editPharmacy(pharmacy) {
    return ApiService.post(`pharmacies/updatepharmacy`, pharmacy)
  },
  getMyPharmacies() {
    return ApiService.get("pharmacies/mypharmacies")
  },
}
